import { quotationsListTypes } from './actionTypes';

export const getQuotationsList = (payload: any) => ({
    type: quotationsListTypes.GET_QUOTATIONS_LIST,
    payload,
});

export const getQuotationsListSuccess = (payload: any) => ({
    type: quotationsListTypes.GET_QUOTATIONS_LIST_SUCCESS,
    payload,
});

export const getQuotationsListFail = (error: any) => ({
    type: quotationsListTypes.GET_QUOTATIONS_LIST_FAIL,
    payload: error,
});

export const getMilestoneConfigQT = () => ({
    type: quotationsListTypes.GET_MILESTONESCONFIG_QT,
});

export const getMilestoneConfigQTSuccess = (payload: any) => ({
    type: quotationsListTypes.GET_MILESTONESCONFIG_QT_SUCCESS,
    payload,
});

export const getMilestoneConfigQTFail = (payload: any) => ({
    type: quotationsListTypes.GET_MILESTONESCONFIG_QT_FAIL,
    payload,
});
